<script lang="ts">
  import type { HTMLAnchorAttributes, HTMLButtonAttributes } from 'svelte/elements';

  interface HtmlButton extends HTMLButtonAttributes {
    tag?: 'button';
    active?: boolean;
    divider?: boolean;
  }

  interface HtmlAnchor extends HTMLAnchorAttributes {
    tag: 'a';
    active?: boolean;
    divider?: boolean;
  }

  type Props = HtmlButton | HtmlAnchor;

  let { active, divider, tag = 'button', ...props }: Props = $props();
</script>

<li>
  {#if divider}
    <hr class="dropdown-divider" />
  {:else if tag === 'a'}
    <a class="dropdown-item" {...props as HTMLAnchorAttributes} aria-current={active ? 'page' : undefined}>
      {@render props.children?.()}
    </a>
  {:else}
    <button class="dropdown-item" class:active {...props as HTMLButtonAttributes}>
      {@render props.children?.()}
    </button>
  {/if}
</li>
